module.exports = __webpack_public_path__ + "img/macao.b5bb71da.svg";